import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

const useDeleteTourPlanning = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);

  const deleteTourPlanning = useCallback(async ({ tourPlanningId }) => {
    setIsDeleting(true);
    setError(null);

    try {
      if (!tourPlanningId) {
        throw new Error("L'ID de la ligne tour planning est requis");
      }

      const response = await fleetApi.delete(
        `/tours-planning/${tourPlanningId}`
      );

      if (response.status === 200) {
        return {
          success: true,
          message: response.data?.message || 'Ligne supprimée avec succès',
        };
      }

      throw new Error('Réponse invalide du serveur');
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err.message ||
        'Impossible de supprimer la ligne du puits de commande';
      setError(message);
      throw new Error(message);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  const resetError = useCallback(() => {
    setError(null);
  }, []);

  return {
    deleteTourPlanning,
    isDeleting,
    error,
    resetError,
  };
};

export default useDeleteTourPlanning;
